import { Typography, styled, styledForMobile } from "@l2r-front/l2r-ui"

import { MapWithSearchBar as L2RMapWithSearchBar } from "../MapWithSearchBar"

const anchorStyle = (theme) => ({
    position: "absolute",
    display: "flex",
    gap: theme.spacing(3),
    zIndex: 3,
    pointerEvents: "none",

    "& > *": {
        width: "fit-content",
        pointerEvents: "auto",
    },
})

export const TopLeftAnchor = styledForMobile("div")(({ isMobile, theme }) => ({
    ...anchorStyle(theme),
    top: theme.spacing(isMobile ? 4.5 : 3),
    left: theme.spacing(3),
    flexDirection: "column",
    width: "fit-content",
    zIndex: isMobile ? 2 : 4,
}))

export const TopRightAnchor = styledForMobile("div")(({ isMobile, theme }) => ({
    ...anchorStyle(theme),
    alignItems: "flex-end",
    display: "flex",
    flexDirection: "column",
    right: theme.spacing(3),
    top: theme.spacing(isMobile ? 3 : 4.5),
    width: isMobile ? `calc(100% - ${theme.spacing(6)})` : "fit-content",
    zIndex: isMobile ? 4 : 2,
}))

export const BottomRightAnchor = styled("div")(({ theme }) => ({
    ...anchorStyle(theme),
    bottom: theme.spacing(9),
    right: theme.spacing(2),
    flexDirection: "column",
}))


export const RoadContainer = styled("div")(({ theme }) => ({
    backgroundColor: "white",
    borderRadius: theme.spacing(3),
    padding: theme.spacing(2, 3),
    width: "fit-content",
    maxWidth: "100%",
}))

export const RoadText = styled(Typography)(() => ({
    display: "block",
    width: "100%",
}))

export const MapWithSearchBar = styled(L2RMapWithSearchBar)(({ theme }) => ({
    "& .mapboxgl-canvas": {
        borderRadius: theme.spacing(3),
    },
}))